/* mg-product-bundles.js — MudGear product page bundle tier picker (vanilla JS) */

(function () {
  'use strict';

  /* ── Init ───────────────────────────────────────────────────────────────── */
  function init() {
    var bundles = document.querySelectorAll('[data-mg-bundles]');
    if (!bundles.length) return;

    bundles.forEach(setupBundle);

    // Listen for variant changes — Impulse fires `variant:change` with
    // `evt.detail.variant`. Confirmed via Archetype's developer docs.
    document.addEventListener('variant:change', handleVariantChange);
  }

  /* ── Per-bundle setup ───────────────────────────────────────────────────── */
  function setupBundle(bundleEl) {
    var tiersContainer = bundleEl.querySelector('[data-mg-bundle-tiers]');
    if (!tiersContainer) return;

    var productForm = findProductForm(bundleEl);
    if (!productForm) {
      console.warn('[mg-product-bundles] No /cart/add product form found near bundle section');
      return;
    }

    // Click anywhere on a tier card → select it. The card is a <label>, but
    // we still attach the listener at container level so we can manage the
    // selected-class on siblings as a side effect.
    tiersContainer.addEventListener('click', function (e) {
      var tierCard = e.target.closest('[data-tier-index]');
      if (!tierCard) return;
      if (tierCard.classList.contains('mg-product-bundles__tier--disabled')) {
        e.preventDefault();
        return;
      }
      selectTier(tiersContainer, tierCard, productForm);
    });

    // Keyboard support — arrow keys cycle between tiers within the radiogroup
    tiersContainer.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var cards = Array.from(tiersContainer.querySelectorAll('[data-tier-index]:not(.mg-product-bundles__tier--disabled)'));
      if (!cards.length) return;
      var current = tiersContainer.querySelector('.mg-product-bundles__tier--selected');
      var currentIdx = cards.indexOf(current);
      var delta = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
      var nextIdx = (currentIdx + delta + cards.length) % cards.length;
      selectTier(tiersContainer, cards[nextIdx], productForm);
      cards[nextIdx].focus();
      e.preventDefault();
    });

    // Sync the form's quantity input with the default-selected tier on load
    var defaultTier = tiersContainer.querySelector('.mg-product-bundles__tier--selected');
    if (defaultTier) {
      updateFormQuantity(productForm, defaultTier.dataset.tierQuantity);
    }
  }

  /* ── Tier selection ─────────────────────────────────────────────────────── */
  function selectTier(tiersContainer, tierCard, productForm) {
    // Visual / a11y state
    tiersContainer.querySelectorAll('[data-tier-index]').forEach(function (el) {
      el.classList.remove('mg-product-bundles__tier--selected');
      el.setAttribute('aria-checked', 'false');
    });
    tierCard.classList.add('mg-product-bundles__tier--selected');
    tierCard.setAttribute('aria-checked', 'true');

    // Native radio (label[for] would handle this, but we're using the label as
    // the control wrapper, so set the inner radio explicitly).
    var radio = tierCard.querySelector('.mg-product-bundles__tier-radio');
    if (radio) radio.checked = true;

    // The crucial bit — sync the form's hidden quantity input. When the
    // customer clicks Add to Cart, mg-cart-drawer's interceptor reads this
    // value and posts it to /cart/add.js.
    updateFormQuantity(productForm, tierCard.dataset.tierQuantity);
  }

  /* ── Helpers ────────────────────────────────────────────────────────────── */
  function findProductForm(bundleEl) {
    // Prefer the form that contains us (in case the section is INSIDE the form).
    var form = bundleEl.closest('form[action*="/cart/add"]');
    if (form) return form;
    // Fallback to the first product form on the page.
    return document.querySelector('form[action*="/cart/add"]');
  }

  function updateFormQuantity(form, qty) {
    if (!form || !qty) return;
    var qtyInput = form.querySelector('input[name="quantity"]');
    if (!qtyInput) {
      qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity';
      form.appendChild(qtyInput);
    }
    qtyInput.value = qty;
  }

  /* ── Variant change cascade ─────────────────────────────────────────────── */
  function handleVariantChange(evt) {
    var variant = evt && evt.detail && evt.detail.variant;
    if (!variant) return;

    document.querySelectorAll('[data-mg-bundles]').forEach(function (bundleEl) {
      bundleEl.querySelectorAll('[data-tier-index]').forEach(function (tierCard) {
        // Recompute display price for new variant, mirroring Shopify's
        // discount engine: automatic discounts use allocation method "each" —
        // the per-UNIT discount is FLOORED to the cent before multiplying by
        // quantity (i.e., the sale price rounds UP, never down).
        var pct = parseFloat(tierCard.dataset.tierDiscountPct) || 0;
        var qty = parseInt(tierCard.dataset.tierQuantity, 10) || 1;
        var discountRaw = variant.price * pct / 100;
        // Precision guard: round to 6 decimals first so float artifacts like
        // 459.89999999 don't floor to 458.
        var discountCents = Math.floor(Math.round(discountRaw * 1e6) / 1e6);
        var newPriceCents = variant.price - discountCents;
        var displayEl = tierCard.querySelector('[data-display-price]');
        if (displayEl) {
          var suffixEl = displayEl.querySelector('[data-price-suffix]');
          var suffixText = suffixEl ? suffixEl.outerHTML : '';
          displayEl.innerHTML = formatMoney(newPriceCents) + suffixText;
        }

        // Recompute totals + savings rows (present when "Show tier totals
        // + savings" is enabled in the customizer)
        var regTotalCents = variant.price * qty;
        var saleTotalCents = newPriceCents * qty;
        var savingsCents = regTotalCents - saleTotalCents;

        var regTotalEl = tierCard.querySelector('[data-reg-total]');
        if (regTotalEl) regTotalEl.textContent = formatMoney(regTotalCents);

        var saleTotalEl = tierCard.querySelector('[data-sale-total]');
        if (saleTotalEl) saleTotalEl.textContent = formatMoney(saleTotalCents);

        var savingEl = tierCard.querySelector('[data-tier-saving]');
        if (savingEl) {
          if (savingsCents > 0) {
            var template = savingEl.dataset.savingTemplate || 'save __AMT__';
            savingEl.textContent = template.replace('__AMT__', formatMoney(savingsCents));
            savingEl.hidden = false;
          } else {
            savingEl.hidden = true;
          }
        }

        // Mirror availability: disable tier if the variant isn't purchasable
        if (variant.available) {
          tierCard.classList.remove('mg-product-bundles__tier--disabled');
          tierCard.removeAttribute('aria-disabled');
          var radio = tierCard.querySelector('.mg-product-bundles__tier-radio');
          if (radio) radio.disabled = false;
        } else {
          tierCard.classList.add('mg-product-bundles__tier--disabled');
          tierCard.setAttribute('aria-disabled', 'true');
          var radio2 = tierCard.querySelector('.mg-product-bundles__tier-radio');
          if (radio2) radio2.disabled = true;
        }
      });
    });
  }

  /* ── Money formatting ───────────────────────────────────────────────────── */
  function formatMoney(cents) {
    // Use the theme's existing money formatter when available (Impulse exposes
    // it on the global theme object). Fall back to a plain $X.XX otherwise.
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var format = (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || '${{amount}}';
      return window.Shopify.formatMoney(cents, format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  /* ── Boot ───────────────────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
